import { Component, input } from '@angular/core';
import { EmailDto } from '@workspace/data-types';
import { ObfuscateEmailPipe } from '../../../../../pipes/obfuscate-email.pipe';

@Component({
  selector: 'aura-contact-infos-email-display',
  templateUrl: './contact-infos-email-display.component.html',
  imports: [ObfuscateEmailPipe],
})
export class AuraContactInfosEmailDisplayComponent {
  currentContactInfos = input<EmailDto | null>(null);
}
